<template>
  <v-footer
    dark
    :height="height"
    class="footer"
    :style="{
      'background-color': `${appConfig.color.mainDark} !important`,
      'color': appConfig.color.textLight
    }"
  >
    <p class="footer__content pt-1">
      {{ appConfig.footerText }}
    </p>
  </v-footer>
</template>

<script>
export default {
  name: 'MainFooter',

  props: {
    height: {
      type: Number,
      required: false,
      default: 50
    }
  },

  data () {
    return {
      appConfig: this.$appConfig
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer {
    justify-content: center;
    background-color: $color-main-dark !important;
    color: $color-text-light;

    &__content {
      text-align: center;
      text-transform: uppercase;
      color: inherit;
      margin: 0;

      @media(max-width: $cp-laptop-breakpoint) {
        font-size: 0.8rem;
      }
    }
  }
</style>
